import React from "react";
import Subheader from "@components/Subheader/Subheader";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";
import DrybulkCargoOperationsList from "./DrybulkCargoOperationsList";
import OperationsQueue from "./OperationsQueue";

const OperationManagementPage: React.FC = () => {
  const { t } = useTranslation();
  const isOperationsUser = useAuthStore((state) => state.isOperationsUser);

  if (isOperationsUser) {
    return <OperationsQueue />;
  }

  return (
    <>
      <Subheader
        testId="operation-management-subheader"
        title={t(`${DRYBULK_CARGO_OPS_LANG_BASE}.queue.page-title`)}
      />
      <div className="relative mt-8 px-24">
        <DrybulkCargoOperationsList />
      </div>
    </>
  );
};

export default OperationManagementPage;
